export default __webpack_public_path__ + "static/media/Vector.f36125ed.svg";